import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DataContainer from 'Components/UI/DataContainer';

import SignUpFlowContent from './SignUpFlowContent';
import { useSignUpFlowContext } from './SignUpFlowContext';

const styles = () => ({
  root: {},
});

const SignUpFlowContainer = ({
  className,
  classes,
}) => {
  const { isInitializing, initializingError } = useSignUpFlowContext();

  return (
    <DataContainer
      className={classes.container}
      component={SignUpFlowContent}
      componentProps={{
        className: classNames(classes.root, className),
      }}
      loading={isInitializing}
      loadingError={initializingError}
    />
  );
};

SignUpFlowContainer.defaultProps = {
  className: '',
};

SignUpFlowContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SignUpFlowContainer);
